// extracted by mini-css-extract-plugin
module.exports = {"card":"BenefitCard_card__wfY6K","heading":"BenefitCard_heading__KkGce","iconText":"BenefitCard_iconText__heeE5","icon":"BenefitCard_icon__6GM2k"};